import { render } from "./PolicyProvisionImportModal.vue?vue&type=template&id=041e3470&scoped=true"
import script from "./PolicyProvisionImportModal.vue?vue&type=script&lang=js"
export * from "./PolicyProvisionImportModal.vue?vue&type=script&lang=js"

import "./PolicyProvisionImportModal.vue?vue&type=style&index=0&id=041e3470&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041e3470"]])

export default __exports__